import React, { useEffect, useState } from 'react';
import { Gift, Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { adminAPI } from '../services/api';

const field = 'border border-gray-300 rounded-md px-2 py-1.5 text-sm w-24 text-gray-900';

/** Admin: reward offered after a verified review (percent, validity, minimum order) + usage stats. */
const ReviewRewardSettings = () => {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { adminAPI.reviewReward().then(setS).catch(() => setS(null)); }, []);
  if (!s) return null;
  const save = async () => {
    setSaving(true);
    try {
      const saved = await adminAPI.saveReviewReward({ enabled: s.enabled, percent: Number(s.percent), validity_days: Number(s.validity_days), min_order: Number(s.min_order) || 0 });
      setS((prev) => ({ ...prev, ...saved }));
      toast.success(saved.enabled ? `Récompense avis active : -${saved.percent} % pendant ${saved.validity_days} jours` : 'Récompense avis désactivée');
    } catch (e) { toast.error(e.response?.data?.detail || 'Enregistrement impossible'); }
    finally { setSaving(false); }
  };
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 flex flex-wrap items-center gap-4" data-testid="review-reward-settings">
      <div className="flex items-center gap-2 text-sm font-semibold text-gray-900"><Gift size={18} className="text-orange-500" /> Récompense après avis</div>
      <label className="inline-flex items-center gap-2 text-sm text-gray-700">
        <input type="checkbox" checked={!!s.enabled} onChange={(e) => setS({ ...s, enabled: e.target.checked })} data-testid="review-reward-enabled" className="rounded border-gray-300 text-orange-500" /> Activée
      </label>
      <label className="text-sm text-gray-700 inline-flex items-center gap-1">Remise <input type="number" min="1" max="50" step="1" value={s.percent} onChange={(e) => setS({ ...s, percent: e.target.value })} data-testid="review-reward-percent" className={field} /> %</label>
      <label className="text-sm text-gray-700 inline-flex items-center gap-1">Validité <input type="number" min="1" max="365" step="1" value={s.validity_days} onChange={(e) => setS({ ...s, validity_days: e.target.value })} data-testid="review-reward-days" className={field} /> jours</label>
      <label className="text-sm text-gray-700 inline-flex items-center gap-1">Minimum <input type="number" min="0" step="1" value={s.min_order} onChange={(e) => setS({ ...s, min_order: e.target.value })} data-testid="review-reward-min" className={field} /> €</label>
      <span className="text-xs text-gray-500" data-testid="review-reward-stats">{s.granted} code(s) offert(s) · {s.used} utilisé(s)</span>
      <Button size="sm" onClick={save} disabled={saving} data-testid="review-reward-save" className="bg-orange-500 hover:bg-orange-600 text-white ml-auto">{saving ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Save size={14} className="mr-1" />} Enregistrer</Button>
    </div>
  );
};

export default ReviewRewardSettings;
